import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import type {
    PsHttp,
    PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PsHttpChannel } from '@patsnap/tahiti-core';
import { getCoreTelecomApiUrlPrefix } from '../../common/constants';
import type { FtoApi } from './fto-api';
import type {
    CreateFtoTaskRequest,
    CreateFtoTaskResponse,
    UploadImagesResponse,
} from './types';

/**
 * FTO API 实现
 * @description 实现所有FTO相关的 API 调用
 */
@injectable()
export class FtoApiImpl extends PsHttpService implements FtoApi {
    _coreTelecomApiUrlPrefix = '';

    constructor(httpClient: PsHttp, httpChannelClient: PsHttpChannel) {
        super(httpClient, httpChannelClient);
        this.init();
    }

    async init() {
        this._coreTelecomApiUrlPrefix = await getCoreTelecomApiUrlPrefix();
    }

    get options() {
        return {
            baseURL: this._coreTelecomApiUrlPrefix,
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }

    /**
     * 创建FTO任务
     */
    async createFtoTask(data: CreateFtoTaskRequest) {
        const res = await this.post<PatSnapSuccessResponseData<CreateFtoTaskResponse>>({
            url: '/fto/submit',
            data,
        });
        return res as unknown as CreateFtoTaskResponse;
    }

    /**
     * 上传图片
     */
    async uploadImages(files: File[], onProgress?: (progress: { percentage: number }) => void): Promise<UploadImagesResponse> {
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file);
        }

        const result = await this.post<PatSnapSuccessResponseData<UploadImagesResponse>>({
            url: '/fto/upload-images',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total) {
                    const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress({ percentage });
                }
            },
        });

        return result.data;
    }
}
